export const SUB_PROFILE_RULES_FETCH = 'SUB_PROFILE_RULES_FETCH';
export const SUB_PROFILE_RULES_IS_FETCING = 'SUB_PROFILE_RULES_IS_FETCING';
export const SUB_PROFILE_RULES_API = 'subprofiles';
export const SUB_PROFILE_RULES_EDIT = 'SUB_PROFILE_RULES_EDIT';
export const SUB_PROFILE_RULES_SAVE = 'SUB_PROFILE_RULES_SAVE';


// WEBPACK FOOTER //
// ./src/constants/subProfileRules.js